import styled from "styled-components";
import media from "../../static/style/media";

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1300px;
`;
export const ContentContainer = styled.div`
  width: 100%;
  padding: 20px 50px;
  height: fit-content;
  margin: 0 auto;
  ${media.small`
    padding: 0px 8px;
    width: 100%;
  `};
`;
